<template>
  <v-card :loading="loading" class="mx-auto my-12" max-width="474">
    <v-img height="250" :src="image03"></v-img>

    <v-card-title
      >Entre em contato conosco do
      <span style="font-family: 'Fontdiner Swanky', serif;"
        >VIOLENT NOISE</span
      ></v-card-title
    >

    <!--
    <v-card-text>
      <v-row align="center" class="mx-0">
        <v-rating
          :value="4.5"
          color="amber"
          dense
          half-increments
          readonly
          size="14"
        ></v-rating>

        <div class="grey--text ml-4">4.5 (413)</div>
      </v-row>
    </v-card-text>
-->

    <v-divider class="mx-4"></v-divider>

    <v-card-title>Envie sua mensagem</v-card-title>

    <v-card-text>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field
          v-model="name"
          :counter="50"
          :rules="nameRules"
          label="Nome"
          required
        ></v-text-field>

        <v-text-field
          v-model="email"
          :rules="emailRules"
          label="E-mail"
          required
        ></v-text-field>

        <v-text-field
          v-model="telefone"
          :rules="telefoneRules"
          label="Telefone"
          required
          type="tel"
        ></v-text-field>

        <!--
    <v-select
      v-model="select"
      :items="items"
      :rules="[v => !!v || 'Item is required']"
      label="Item"
      required
    ></v-select>
-->
        <v-textarea
          v-model="mensagem"
          :counter="255"
          :rules="mensagemRules"
          label="Mensagem"
          required
          multiline
        ></v-textarea>

        <!--
    <v-checkbox
      v-model="checkbox"
      :rules="[v => !!v || 'Você deve aceitar as condições!']"
      label="Você concorda?"
      required
    ></v-checkbox>
-->
        <v-btn
          :disabled="!valid"
          color="success"
          class="mr-4"
          @click="validate"
        >
          Enviar
        </v-btn>

        <!--
    <v-btn
      color="error"
      class="mr-4"
      @click="reset"
    >
      Reset Form
    </v-btn>

    <v-btn
      color="warning"
      @click="resetValidation"
    >
      Reset Validation
    </v-btn>
-->
      </v-form>
    </v-card-text>
    <!--
    <v-card-actions>
      <v-btn color="deep-purple accent-4" text @click="reserve">
        Envie um email
      </v-btn>
    </v-card-actions>
-->

    <v-dialog v-model="dialog" max-width="290">
      <v-card>
        <v-card-title class="headline" v-html="header"
          ></v-card-title
        >

        <v-card-text v-html="message">
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="dialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import axios from "axios";

const image3 = require("@/assets/images/content/drums.jpg");

export default {
  data: () => ({
    dialog: false,
    header: '',
    message: '',
    image03: image3,
    loading: false,
    selection: 0,
    valid: true,
    name: "",
    nameRules: [
      v => !!v || "O nome é obrigatorio",
      v =>
        (v && v.length > 10) ||
        "O campo nome tem que ter no minimo 10 caracteres"
    ],
    email: "",
    emailRules: [
      v => !!v || "O e-mail é obrigatorio",
      v => /.+@.+\..+/.test(v) || "O e-mail deve ser valido"
    ],
    telefone: "",
    telefoneRules: [
      v => !!v || "O telefone é obrigatorio"
      //v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
    ],
    mensagem: "",
    mensagemRules: [
      v => !!v || "A mensagem é obrigatorio",
      v =>
        (v && v.length >= 10) ||
        "O campo mensagem tem que ter no minimo 10 caracteres"
    ]
  }),

  methods: {
    validate() {
      if (this.$refs.form.validate()) {
        //this.snackbar = true;

        const msg = {
          nome: this.name,
          telefone: this.telefone,
          email: this.email,
          mensagem: this.mensagem
        };

        axios
          //.post("https://localhost:44392/api/sendEmail", msg)
          .post("https://webapiambiware.azurewebsites.net/api/sendemail", msg)
          .then(ret => {
            console.log("Enviou o email", ret);
            this.header = "Contato";
            this.message = ret.data;
            this.dialog = true;
            this.mensagem = '';
          })
          .catch(error => {
            console.log("Erro ao enviar o email: ", error);
            this.header = "Erro!";
            this.message = "Erro ao enviar a Mensagem!"
            this.dialog = true;
          });
      }
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    }
  }
};
</script>

<style></style>
